/* Feel Good: Subscription validation + savings line.
   Keeps cart drawer / cart page in sync with cart.js after every cart change.
   Renders panel HTML from JS so AJAX re-renders don't desync state.
   2026-07-31: per-plan totals, mixed-plan state, plan-chooser CTA.
   2026-09-22 (v2.3): builder / plan-chooser links carry the locale prefix (/en/...).
*/
(function(){
  if (window.fgValidateInit) return;
  window.fgValidateInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function R(path){ return ROOT.replace(/\/$/, '') + path; }

  var BYOB = {
    690891161940: { tier: 'Starter', required: 12, url: R('/pages/subscribe-starter') },
    690891194708: { tier: 'Regular', required: 24, url: R('/pages/subscribe-regular') },
    690891227476: { tier: 'Family',  required: 48, url: R('/pages/subscribe-family')  }
  };
  var CHOOSE_URL = R('/pages/subscribe');

  function locale(){
    var l = (document.documentElement.lang || 'en').toLowerCase();
    return l.indexOf('el') === 0 ? 'el' : 'en';
  }

  function fmtMoney(cents){
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + v;
  }

  function tStrings(){
    if (locale() === 'el') return {
      bars: 'μπάρες',
      under_pre: 'Λείπουν', under_mid: 'για τη συνδρομή σου',
      under_note: 'Πρόσθεσε τις γεύσεις που αγαπάς και κλείδωσε την έκπτωσή σου.',
      under_cta: 'Πρόσθεσε γεύσεις →',
      over_pre: 'Έχεις', over_mid: 'παραπάνω για το',
      over_note: 'Αφαίρεσε την ακριβή ποσότητα ή αναβάθμισε σε μεγαλύτερο πλάνο.',
      over_cta: 'Προσάρμοσε το κουτί →',
      alt_plan: 'ή άλλαξε πλάνο',
      mixed_title: 'Το καλάθι έχει μπάρες από 2 πλάνα',
      mixed_note: 'Πάτησε παρακάτω για να τακτοποιήσεις το κουτί σου. Οι μπάρες του άλλου πλάνου θα αφαιρεθούν αυτόματα όταν ολοκληρώσεις.',
      mixed_cta: 'Τακτοποίησε το κουτί →',
      ok: 'Το κουτί είναι γεμάτο: συνδρομή',
      savings_label: 'Εξοικονόμηση συνδρομής'
    };
    return {
      bars: 'bars',
      under_pre: 'Missing', under_mid: 'for your subscription',
      under_note: 'Add the flavors you love and lock in your discount.',
      under_cta: 'Add flavors →',
      over_pre: 'You have', over_mid: 'extra for',
      over_note: 'Remove the exact quantity or upgrade to a larger plan.',
      over_cta: 'Adjust your box →',
      alt_plan: 'or change plan',
      mixed_title: 'Your cart has bars from 2 plans',
      mixed_note: 'Tap below to tidy up your box. The other plan’s bars will be removed automatically when you complete it.',
      mixed_cta: 'Tidy up your box →',
      ok: 'Ready for checkout: subscription',
      savings_label: 'Subscription savings'
    };
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"]/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; });
  }

  function renderPanelHTML(state, total, required, tier, editUrl, T, tiersLabel){
    var pct = required > 0 ? Math.min(100, Math.round(total * 100 / required)) : 100;
    var icon = state === 'ok' ? '✅' : (state === 'under' ? '🍫' : '⚠️');
    var diff = required - total;
    var excess = total - required;
    var titleHtml;
    if (state === 'ok') {
      titleHtml = T.ok + ' <strong>' + escapeHtml(tier) + '</strong>';
    } else if (state === 'under') {
      titleHtml = T.under_pre + ' <strong>' + diff + ' ' + T.bars + '</strong> ' + T.under_mid + ' <strong>' + escapeHtml(tier) + '</strong>';
    } else if (state === 'over') {
      titleHtml = T.over_pre + ' <strong>' + excess + ' ' + T.bars + '</strong> ' + T.over_mid + ' <strong>' + escapeHtml(tier) + '</strong>';
    } else { /* mixed */
      titleHtml = T.mixed_title + ' <strong>(' + escapeHtml(tiersLabel) + ')</strong>';
    }

    var html = '<div class="fg-sub-validate__head">' +
      '<span class="fg-sub-validate__icon" aria-hidden="true">' + icon + '</span>' +
      '<p class="fg-sub-validate__title">' + titleHtml + '</p>' +
      '</div>';

    if (state !== 'mixed') {
      html += '<div class="fg-sub-validate__progress" aria-hidden="true">' +
        '<div class="fg-sub-validate__bar"><div class="fg-sub-validate__fill" style="width: ' + pct + '%;"></div></div>' +
        '<span class="fg-sub-validate__count">' + total + ' / ' + required + ' ' + T.bars + '</span>' +
      '</div>';
    }

    if (state === 'under') {
      html += '<p class="fg-sub-validate__note">' + T.under_note + '</p>' +
              '<a href="' + escapeHtml(editUrl) + '" class="fg-sub-validate__cta">' + T.under_cta + '</a>';
    } else if (state === 'over') {
      html += '<p class="fg-sub-validate__note">' + T.over_note + '</p>' +
              '<a href="' + escapeHtml(editUrl) + '" class="fg-sub-validate__cta">' + T.over_cta + '</a>' +
              '<a href="' + CHOOSE_URL + '" class="fg-sub-validate__alt">' + T.alt_plan + '</a>';
    } else if (state === 'mixed') {
      html += '<p class="fg-sub-validate__note">' + T.mixed_note + '</p>' +
              '<a href="' + escapeHtml(editUrl) + '" class="fg-sub-validate__cta">' + T.mixed_cta + '</a>' +
              '<a href="' + CHOOSE_URL + '" class="fg-sub-validate__alt">' + T.alt_plan + '</a>';
    }
    return html;
  }

  function ensurePanel(){
    /* If a panel doesn't exist yet (e.g. initial render had no BYOB items), inject one. */
    if (document.querySelector('.fg-sub-validate')) return;
    var hosts = [];
    var drawer = document.querySelector('cart-drawer .drawer__footer .cart-drawer__footer');
    if (drawer) hosts.push(drawer);
    var pageFooter = document.querySelector('#main-cart-footer .cart__footer');
    if (pageFooter) hosts.push(pageFooter);
    hosts.forEach(function(host){
      var p = document.createElement('div');
      p.className = 'fg-sub-validate fg-sub-validate--ok';
      p.style.display = 'none';
      host.appendChild(p);
    });
  }

  function ensureSavings(){
    /* Inject a savings line near each totals block if missing. */
    var totals = document.querySelectorAll('.totals');
    totals.forEach(function(tb){
      if (tb.querySelector('.fg-savings-line')) return;
      var span = document.createElement('p');
      span.className = 'fg-savings-line';
      span.style.display = 'none';
      tb.parentNode.insertBefore(span, tb.nextSibling);
    });
  }

  function update(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var subSavingsCents = 0;
        var perPlan = {};      /* planId -> qty */
        var planOrder = [];    /* newest first (cart.items is newest-first) */
        cart.items.forEach(function(item){
          if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
            var sp = item.selling_plan_allocation.selling_plan.id;
            if (BYOB[sp]) {
              if (!(sp in perPlan)) { perPlan[sp] = 0; planOrder.push(sp); }
              perPlan[sp] += item.quantity;
            }
            /* Sum savings: original_price - final_price per unit, times qty */
            if (item.original_price > item.final_price) {
              subSavingsCents += (item.original_price - item.final_price) * item.quantity;
            }
          }
        });

        var T = tStrings();
        ensurePanel();
        ensureSavings();

        var panels = document.querySelectorAll('.fg-sub-validate');
        var plans = planOrder.slice();
        var state = 'ok';
        var blocked = false;

        if (plans.length === 0) {
          panels.forEach(function(p){ p.style.display = 'none'; });
        } else if (plans.length === 1) {
          var planId = plans[0];
          var meta = BYOB[planId];
          var total = perPlan[planId];
          state = (total === meta.required) ? 'ok' : (total < meta.required ? 'under' : 'over');
          blocked = state !== 'ok';
          panels.forEach(function(p){
            p.style.display = '';
            p.className = 'fg-sub-validate fg-sub-validate--' + state;
            p.dataset.planId = planId;
            p.dataset.state = state;
            p.innerHTML = renderPanelHTML(state, total, meta.required, meta.tier, meta.url, T, '');
          });
        } else {
          /* Mixed plans in cart: block checkout, send user to the NEWEST plan's builder
             (completing it auto-removes the other plan's lines). */
          state = 'mixed';
          blocked = true;
          var newest = plans[0];
          var tiersLabel = plans.map(function(sp){ return BYOB[sp].tier; }).join(' + ');
          panels.forEach(function(p){
            p.style.display = '';
            p.className = 'fg-sub-validate fg-sub-validate--over';
            p.dataset.state = 'mixed';
            p.innerHTML = renderPanelHTML('mixed', 0, 0, '', BYOB[newest].url, T, tiersLabel);
          });
        }

        /* Savings line */
        var savingsLines = document.querySelectorAll('.fg-savings-line');
        savingsLines.forEach(function(s){
          if (subSavingsCents > 0) {
            s.style.display = '';
            s.innerHTML = '<span class="fg-savings-line__icon" aria-hidden="true">✨</span> ' +
                          '<span class="fg-savings-line__label">' + T.savings_label + '</span>' +
                          '<strong class="fg-savings-line__amount">−' + fmtMoney(subSavingsCents) + '</strong>';
          } else {
            s.style.display = 'none';
          }
        });

        /* Disable / enable checkout buttons */
        var btns = document.querySelectorAll('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
        btns.forEach(function(b){
          b.disabled = blocked;
          if (blocked) b.classList.add('fg-checkout-blocked');
          else b.classList.remove('fg-checkout-blocked');
        });
        var dyn = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
        dyn.forEach(function(w){ w.style.display = blocked ? 'none' : ''; });
      })
      .catch(function(err){ console.warn('[fg-validate] update failed', err); });
  }

  /* Hook fetch to detect cart mutations */
  var origFetch = window.fetch;
  window.fetch = function(){
    var url = arguments[0];
    var p = origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlStr && /\/cart\/(change|add|update|clear)/.test(urlStr)) {
      p.then(function(){ setTimeout(update, 100); });
    }
    return p;
  };

  /* Hook XMLHttpRequest as fallback (some apps use it) */
  var origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url){
    this.addEventListener('load', function(){
      if (typeof url === 'string' && /\/cart\/(change|add|update|clear)/.test(url)) {
        setTimeout(update, 100);
      }
    });
    return origXhrOpen.apply(this, arguments);
  };

  /* Run once on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  window.fgValidateUpdate = update;
})();
